module.exports = __webpack_public_path__ + "img/eu-round.4f0bdd6c.svg";